<template>
  <header class="header header--desktop">
    <div class="header__inner container">
      <div class="header__logo">
        <router-link :to="{ name: 'home' }" class="header__logo-link">
          <img
            class="header__logo-img header__logo-img--light"
            src="@/assets.app/images/logo.svg"
            alt="Shortform App"
          />
          <img
            class="header__logo-img header__logo-img--dark"
            src="@/assets.app/images/logo-dark.svg"
            alt="Shortform App"
          />
        </router-link>
      </div>
      <AppMenu class="header__nav" :view="view" />
      <StartFreeTrialButton
        v-if="view.showCtaButton"
        class="header__trial-btn"
      />
      <HeaderUserMenu class="header__user-menu" :view="view" />
    </div>
  </header>
</template>

<script setup lang="ts">
import { onBeforeMount, Raw, ref } from 'vue'

import { HeaderView } from '@/models/header'

import HeaderUserMenu from '@/app/components/header/UserMenu.vue'
import AppMenu from '@/app/components/header/AppMenu.vue'
import StartFreeTrialButton from './StartFreeTrialButton.vue'

const view = ref<Raw<HeaderView>>(new HeaderView())

onBeforeMount(async () => {
  await view.value.init()
})
</script>

<style lang="scss" scoped>
/**
 * Extends `.header` class, which is defined in `@/assets.app/css/components/_header.scss`
 */
.header {
  background-color: $c-white;
  border-bottom: 1px solid $c-border;
  @media only screen and (max-width: $w-tablet-s) {
    display: none;
  }

  &__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__logo {
    width: 161px;
    flex-shrink: 0;
    margin-right: 25px;
    @media only screen and (max-width: $w-max-content-width) {
      width: 140px;
    }
  }

  &__logo-link {
    display: block;
    @include hover {
      opacity: 0.5;
    }
  }

  &__logo-img--dark {
    display: none;
  }

  &__nav {
    flex: 1;

    @media only screen and (min-width: $w-max-content-width) {
      justify-content: space-between;
      gap: 0;
      min-width: 0;
      width: 100%;
      max-width: 700px;
    }
  }

  &__user-menu,
  &__trial-btn {
    margin-left: 12px;
  }
}

.night-mode .header {
  background-color: $c-dark-1;
  border-bottom: 1px solid $c-dark-3;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);

  &__logo-img--light {
    display: none;
  }

  &__logo-img--dark {
    display: block;
  }
}
</style>
